// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import JsonExcel from 'vue-json-excel'

import {router} from './router'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import './assets/fonts/fonts.css'

import {store} from './store'
import '@mdi/font/css/materialdesignicons.css'
import GAuth from 'vue-google-oauth2'
import moment from 'moment'
import BaseButton from '@/components/base/BaseButton'
import './assets/sass/variables.css'

require('./assets/fonts/fonts.css')
Vue.component('downloadExcel', JsonExcel)

Vue.use(Vuetify, { iconfont: 'mdi' })
Vue.config.productionTip = false

/* eslint-disable no-new */
const gauthOption = {
  clientId: '325728370755-lbiuf6lv1n5teliv38qb1ke18lu9hso9.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)

Vue.mixin({
  data () {
    return {
      // reportTypeItems: [{'id':2,'name':'КМ'}, {'id':1,'name':'Аутрич'},{'id':3,'name':'Юристы'}],
      reportTypeItems: [{'name':'КМ'}, {'name':'Аутрич'},{'name':'Юристы'},{'name':'ЛГБТКИ+'},{'name':'Психолог'}],
      reportAvailabilityItems: [{'name':'Индивидуальный', 'id':'Индивидуальный'},{'name':'Глобальный', 'id':'Глобальный'}],
      // reportTypeItemsMapping:  {'KM': {'id':2,'name':'КМ'},'Аутрич':{'id':1,'name':'Аутрич'},'Юристы':{'id':3,'name':'Юристы'}},
      ignoreList: ['user_roles','report_type', 'additional_info', 'classificator', 'additional_name']}
  },
  computed: {
    // project () {
    //   let vm = this
    //   return this.$store.state.tableData.projects.filter(v => v.id === vm.$store.state.newOutreachReports.project)[0]
    // },
    // selectedUsers () {
    //   let vm = this
    //   return this.$store.state.tableData.users.filter(v =>  vm.$store.state.newOutreachReports.users.indexOf(v.id)>-1)
    // },
    currentUser () {
      return this.$store.state.authentication.user
    },
    isAdmin () {
      if (this.currentUser && this.currentUser.rights !== undefined) {
        return this.currentUser.user_info.type === 'админ'
      } else return false
    },
  },
  methods: {
    formSubmit () {
      let vm = this
      vm.formHasErrors = false
      Object.keys(vm.form).forEach(f => {
        if (vm.ignoreList.indexOf(f)===-1) {
          if (!vm.form[f]) vm.formHasErrors = true
          vm.$refs[f].validate(true)
        }
      })
      if (!vm.formHasErrors) vm.$refs["basetable"].save(vm.editItem)
      // this.$store.dispatch("tableData/loadProducts")

    },
    simpleEditClick (newVal) {
      const entries = Object.entries(newVal)
      let vm = this
      entries.forEach(function (elem) {
        vm.editItem[elem[0]] = elem[1]
      })
    },
    isValidDate (s) {
      var bits = s.split('.')
      var d = new Date(bits[2] + '/' + bits[1] + '/' + bits[0])
      return !!(d && (d.getMonth() + 1) == bits[1] && d.getDate() == Number(bits[0]))
    },
    formatDate: function (date) {
      return moment(date)
    },
    getMonth:
     function (date) {
      const [day, month, year] = date.split('.')
      return `${month}.${year}`
    },
    capitalize: function (s) {
      return (s && s[0].toUpperCase() + s.slice(1)) || ""
    },
    fullDateFormat: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    shortDateFormat: function (date) {
      return moment(date).format('MM.YYYY')
    },
    todayDate: function () {
      return moment().format('YYYY-MM-DD')
    },
    firstDayOfTheWeek: function () {
      return moment().startOf('week').format('YYYY-MM-DD')
    },
    lastDayOfTheWeek: function () {
      return moment().endOf('week').format('YYYY-MM-DD')
    },
    firstDayOfTheMonth: function () {
      return moment().startOf('month').format('YYYY-MM-DD')
    },
    lastDayOfTheMonth: function () {
      return moment().endOf('month').format('YYYY-MM-DD')
    },
    firstDayOfTheYear: function (year) {
      let val = year ? moment([year]) : moment()

      return val.startOf('year').format('YYYY-MM-DD')
    },
    lastDayOfTheYear: function (year) {
      let val = year ? moment([year]) : moment()
      return val.endOf('year').format('YYYY-MM-DD')
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      let parsed = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      // this.$emit('dateUpdated', parsed)
      return parsed
    }
  }
})


Vue.component('base-button', BaseButton)

new Vue({
  el: '#app',
  router,
  store,
  vuetify: new Vuetify(),
  components: { App },
  filters: {
    formatDate: function (date) {
      return moment(String(date)).format('DD-MM-YYYY')
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js